/**
 * 샵관리 모바일 웹 셸 — /shop/m/*
 * ERP 레이아웃(사이드바·탭)을 쓰지 않는 독립 화면. 하단 탭으로 5개 화면 이동.
 * 데이터는 PC 화면과 같은 shopStore 를 쓴다.
 */
import React from 'react';
import styled from 'styled-components';
import { NavLink, Routes, Route, Navigate } from 'react-router-dom';
import useTenantCode from 'hooks/useTenantCode';
import MobileHome from './MobileHome';
import MobileRecord from './MobileRecord';
import MobileCustomer from './MobileCustomer';
import MobileStock from './MobileStock';
import MobilePass from './MobilePass';
import MobileReservation from './MobileReservation';
import { M } from './mobileUi';

const Shell = styled.div`
  min-height: 100%;
  background: ${M.bg};
  max-width: 640px;
  margin: 0 auto;
  font-family: 'Noto Sans KR', 'Wanted Sans', system-ui, sans-serif;
`;

const Brand = styled.header`
  position: sticky;
  top: 0;
  z-index: 9;
  background: ${M.bg};
  text-align: center;
  padding: 14px 0 10px;
  border-bottom: 1px solid ${M.line};
  .w {
    font-family: ${M.serif};
    font-size: 22px;
    letter-spacing: 0.32em;
    text-indent: 0.32em;
    color: ${M.text};
  }
  .d { font-size: 10px; letter-spacing: 0.3em; text-indent: 0.3em; color: ${M.gold}; margin-top: 2px; }
`;

const Bar = styled.nav`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  max-width: 640px;
  margin: 0 auto;
  background: #fff;
  border-top: 1px solid ${M.line};
  padding-bottom: env(safe-area-inset-bottom);
  a {
    flex: 1;
    min-width: 0;
    min-height: 56px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 12px;
    letter-spacing: 0.12em;
    color: ${M.muted};
    text-decoration: none;
    position: relative;
  }
  a::before {
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: transparent;
  }
  a.active { color: ${M.red}; font-weight: 700; }
  a.active::before { background: ${M.red}; }
`;

const TABS = [
  { to: '/shop/m', end: true, label: '요약' },
  { to: '/shop/m/reservation', label: '예약' },
  { to: '/shop/m/record', label: '시술' },
  { to: '/shop/m/customer', label: '고객' },
  { to: '/shop/m/pass', label: '회원권' },
  { to: '/shop/m/stock', label: '재고' },
];

const ShopMobileApp = () => {
  const tc = useTenantCode();
  return (
    <Shell>
      <Brand>
        <div className="w">LAGO SANA</div>
        <div className="d">SKIN CARE MANAGER</div>
      </Brand>
      <Routes>
        <Route index element={<MobileHome tc={tc} />} />
        <Route path="reservation" element={<MobileReservation tc={tc} />} />
        <Route path="record" element={<MobileRecord tc={tc} />} />
        <Route path="customer" element={<MobileCustomer tc={tc} />} />
        <Route path="pass" element={<MobilePass tc={tc} />} />
        <Route path="stock" element={<MobileStock tc={tc} />} />
        <Route path="*" element={<Navigate to="/shop/m" replace />} />
      </Routes>
      <Bar>
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end}>
            <span>{t.label}</span>
          </NavLink>
        ))}
      </Bar>
    </Shell>
  );
};

export default ShopMobileApp;
